import { forwardRef } from 'react';
import ItemInternal from './item-internal';
const Item = forwardRef(ItemInternal);
export default Item;
